import React from 'react';
import { getCookiePolicyPath, getPrivacyPolicyPath } from '../../constants/routes';
import i18n from '../../utils/i18n';
import SquareButton from '../SquareButton';

interface Props {
  icon: string;
  header: string;
  title: string;
  subtitle: string;
  loginButton: string;
  helpButton: string;
  clickHandler: () => void;
}

const UnauthorisedAlertCardView: React.FC<Props> = ({
  icon, header, title, subtitle, clickHandler, loginButton, helpButton,
}) => (
  <div>
    <div className="flex flex-col border rounded-2xl bg-white drop-shadow-md p-6 max-w-lg">
      <div className="flex items-center">
        <img src={icon} alt={icon} className="w-8 h-8 rounded-lg" />
        <div className="ml-2 text-sm text-light-default-title font-bold">{header}</div>
      </div>

      <div className="mt-6" />
      <div className="text-2xl text-light-default-title font-bold">{title}</div>
      <div className="mt-2 text-sm text-light-default-title font-normal">{subtitle}</div>
      <div className="mt-10" />
      <SquareButton state="blue" label={loginButton} onClick={clickHandler} />
      <SquareButton state="green" label={helpButton} />

      <div className="mt-6 text-center text-sm">
        <a
          href={getPrivacyPolicyPath(i18n.language)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          {i18n.t('sidebar.privacyPolicy')}
        </a>
        <span className="mx-2">|</span>
        <a
          href={getCookiePolicyPath(i18n.language)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          {i18n.t('sidebar.cookiePolicy')}
        </a>
      </div>
    </div>
  </div>
);
export default UnauthorisedAlertCardView;
